import React from 'react';
import { Grid, Switch, Typography, Button } from '@mui/material';
import { numberWithCommas , getServiceConfig} from 'utility';
import { Icons } from 'components';
import useCustomHook from './hooks';

let currencyText = ''

    const fetchConfig = async () => {
      try {
        const res = await getServiceConfig();
        currencyText = res?.result?.currencyLabel
      } catch (err) {
        console.error(err);
      }
    };

    fetchConfig();
  

const getPeriodText = (v) => {
  switch (v) {
    case 'سالانه':
      return 'سال';
    case 'ماهانه':
      return 'ماه';
    case 'هفتگی':
      return 'هفته';
    case 'روزانه':
      return 'روز';
    default:
      return v;
  }
};

const columns = (onClickDetail = () => { }, onChangeStatus = () => { }, actionsList, classes, setShowDialog, setDataDialog ,  currencyText) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه',
    field: 'id',
    align: 'center',
    filtering: false,
  },
  {
    title: 'شروع',
    field: 'startDate', // 1384
    align: 'center',
    dir: 'ltr',
    filtering: false,
  },
  {
    title: 'انقضا',
    field: 'expireDate', // 1384
    align: 'center',
    dir: 'ltr',
    filtering: false,
  },
  {
    title: 'تخصیص به',
    field: 'assignedTo', // 1384
    align: 'center',
    filtering: false,
  },
  {
    title: `به میزان - ${currencyText}`,
    field: 'amount', // 1384
    align: 'center',
    filtering: false,
    render: (rc) => numberWithCommas(rc?.amount),
  },
  {
    title: `میزان مصرف - ${currencyText}`,
    field: 'usageAmount', // 1384
    align: 'center',
    filtering: false,
    render: (rc) => numberWithCommas(rc?.usageAmount),
  },
  {
    title: 'شارژ مجدد',
    field: 'recharge', // 1384
    align: 'center',
    filtering: false,
    render: (rc) =>
      rc?.recharge === 0
        ? '-'
        : `هر ${numberWithCommas(rc?.recharge)} ${getPeriodText(rc?.period)} یک‌بار`,
  },
  ...(actionsList['updateDelegationOtherPage'] ? [{
    title: 'تغییر وضعیت',
    field: 'status', // 1384
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => <ToggleStatus rd={rd} onChangeStatus={onChangeStatus} />,
  }] : []),
  {
    title: 'گزارش‌گیری',
    field: 'export', // 13
    filtering: false,
    align: 'center',
    sorting: false,
    render: (rd) => (
      <Button
        onClick={(e) => {
          onClickDetail(rd.delegationId);
          e.stopPropagation();
        }}
      >
        نمایش گزارش
      </Button>
    ),
  },
  ...((actionsList['detailsDelegationOtherPage']) ? [{
    title: 'عملیات',
    field: 'operationSmall',
    filtering: false,
    sorting: false,
    align: 'right',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rowData) => (
      <Button startIcon={<Icons icon="MoreHorizontal" color="#667585"  size="20" />}
        variant="contained" className={classes.expandBtn}
        onClick={() => {
          setShowDialog(true);
          setDataDialog(rowData)
        }}>
        جزئیات
      </Button>
    ),
  }] : []),
];

const columnsId = {
  invoiceId: '1349',
  tax: '1444',
  invoiceStatus: '1352',
  guildName: '1353',
  decreased: '1354',
  hasMultiInvoice: '1384',
};

const orderingIndexes = [
  null,
  'زمان شروع',
  'زمان انقضا',
  'نام و نام خانوادگی',
  'میزان',
  'استفاده شده',
  'تعداد شارژ مجدد',
  'وضعیت',
  null,
  null,
  null,
];
const ToggleStatus = ({ rd, onChangeStatus }) => {
  const { loading, setLoading } = useCustomHook();
  return (
    <Grid container alignItems="center" justifyContent="center" style={{ opacity: loading ? 0.4 : 1 }}>
      <Switch
        disabled={loading}
        color="primary"
        onChange={async () => {
          setLoading(true);
          await onChangeStatus(rd?.id, !(rd?.status === 'فعال' ? true : false));
          setLoading(false);
        }}
        checked={rd?.status === 'فعال' ? true : false}
        className='iosSwitch'
      />
      <Typography>{rd?.status}</Typography>
    </Grid>
  );
};
const generateData = (rows, query) => {
  return rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      id: row.cols[0],
      startDate: row.cols[9],
      expireDate: row.cols[10],
      assignedTo: row.cols[7],
      amount: row.cols[3],
      usageAmount: row.cols[4],
      recharge: row.cols[11],
      status: row.cols[2],
      export: row.cols[1],
      details: row.cols[1],
      period: row.cols[12],
      delegationId: row.cols[0],
    };
  });
};

export { columns, columnsId, generateData, orderingIndexes };
